/* Brasilhair — scroll reveal, wishlist (localStorage), predictive search */
(function () {
  'use strict';
  document.documentElement.classList.add('brasil-js');
  var euro = function (cents) {
    try { return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' }); }
    catch (e) { return (cents / 100).toFixed(2) + ' €'; }
  };

  /* ── Scroll reveal ── */
  function initReveal() {
    var auto = '.brasil .sec-ey,.brasil .sec-h2,.brasil .sec-sub,.brasil .ed-eyebrow,' +
      '.brasil .ed-h2,.brasil .ed-body,.brasil .ed-stats,.brasil .ed-btns,' +
      '.brasil .coll-hero-content,.brasil .page-hero .ey,.brasil .page-hero h1,.brasil .page-hero p,' +
      '.brasil .hero-kicker,.brasil .hero-h1,.brasil .hero-sub,.brasil .hero-btns,' +
      '.brasil .why-card,.brasil .coll-card,.brasil .rev-card,.brasil .reel,.brasil .seo-cols';
    document.querySelectorAll(auto).forEach(function (e) {
      if (!e.hasAttribute('data-reveal')) e.setAttribute('data-reveal', '');
    });
    var els = document.querySelectorAll('.brasil [data-reveal]');
    if (!('IntersectionObserver' in window) || !els.length) {
      els.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ── Wishlist ── */
  var WKEY = 'brasil_wishlist';
  var W = {
    get: function () { try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (e) { return []; } },
    save: function (a) { localStorage.setItem(WKEY, JSON.stringify(a)); },
    has: function (h) { return this.get().indexOf(h) !== -1; },
    toggle: function (h) {
      var a = this.get(), i = a.indexOf(h);
      if (i === -1) a.push(h); else a.splice(i, 1);
      this.save(a); return i === -1;
    }
  };
  function refreshWishUI() {
    var c = W.get().length;
    document.querySelectorAll('.wish-count').forEach(function (b) {
      b.textContent = c; b.style.display = c ? 'flex' : 'none';
    });
    document.querySelectorAll('.pc-wish').forEach(function (btn) {
      btn.classList.toggle('is-active', W.has(btn.getAttribute('data-handle')));
    });
  }
  function initWishlist() {
    refreshWishUI();
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.pc-wish');
      if (!btn) return;
      e.preventDefault(); e.stopPropagation();
      var added = W.toggle(btn.getAttribute('data-handle'));
      btn.classList.toggle('is-active', added);
      refreshWishUI();
    });
    renderWishlistPage();
  }
  function renderWishlistPage() {
    var grid = document.getElementById('wishlist-grid');
    if (!grid) return;
    var handles = W.get();
    var empty = document.getElementById('wishlist-empty');
    if (!handles.length) { if (empty) empty.style.display = 'block'; grid.innerHTML = ''; return; }
    if (empty) empty.style.display = 'none';
    grid.innerHTML = '';
    handles.forEach(function (h) {
      fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        if (!p) return;
        var img = p.featured_image || (p.images && p.images[0]) || '';
        var card = document.createElement('div'); card.className = 'pc';
        card.innerHTML =
          '<button class="pc-wish is-active" data-handle="' + p.handle + '" aria-label="Retirer"><span class="h-off">&#9825;</span><span class="h-on">&#9829;</span></button>' +
          '<a href="' + p.url + '" class="pc-img"><div class="pc-img-inner" style="background-image:url(\'' + img + '\')"></div></a>' +
          '<div class="pc-body">' +
          (p.type ? '<div class="pc-cat">' + p.type + '</div>' : '') +
          '<div class="pc-name"><a href="' + p.url + '">' + p.title + '</a></div>' +
          '<div class="pc-price-row"><span class="pc-price">' + euro(p.price) + '</span></div>' +
          '</div>';
        grid.appendChild(card);
      });
    });
  }

  /* ── Predictive search ── */
  function initSearch() {
    var ps = document.querySelector('.psearch');
    if (!ps) return;
    var input = ps.querySelector('.psearch-input');
    var results = ps.querySelector('.ps-results');
    var trigger = ps.querySelector('.psearch-trigger');
    var t;
    function open() { ps.classList.add('open'); if (input) input.focus(); }
    function close() { ps.classList.remove('open'); }
    if (trigger) trigger.addEventListener('click', function (e) { e.preventDefault(); ps.classList.contains('open') ? close() : open(); });
    document.addEventListener('click', function (e) { if (!ps.contains(e.target)) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    if (!input) return;
    input.addEventListener('input', function () {
      clearTimeout(t);
      var q = input.value.trim();
      if (q.length < 2) { if (results) results.innerHTML = ''; return; }
      t = setTimeout(function () {
        var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url).then(function (r) { return r.json(); }).then(function (d) {
          var prods = (d.resources && d.resources.results && d.resources.results.products) || [];
          if (!results) return;
          if (!prods.length) { results.innerHTML = '<div class="ps-empty">Aucun résultat pour « ' + q + ' »</div>'; return; }
          results.innerHTML = prods.map(function (p) {
            var img = (p.featured_image && p.featured_image.url) || p.image || '';
            return '<a href="' + p.url + '">' +
              (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<img alt="">') +
              '<span><span class="pt">' + p.title + '</span><br><span class="pp">' + (p.price ? p.price : '') + '</span></span></a>';
          }).join('');
        }).catch(function () {});
      }, 220);
    });
  }

  /* ── Cart drawer (opens on add-to-cart) ── */
  function initCart() {
    var drawer = document.getElementById('BrasilCartDrawer');
    if (!drawer) return;
    var itemsEl = drawer.querySelector('.cd-items');
    var emptyEl = drawer.querySelector('.cd-empty');
    var subEl = drawer.querySelector('.cd-sub-val');
    var countEls = document.querySelectorAll('.cd-count');
    var noteEl = drawer.querySelector('.cd-note');
    var shipMsg = drawer.querySelector('.cd-ship-msg');
    var shipFill = drawer.querySelector('.cd-ship-fill');
    var freeShip = parseInt(drawer.getAttribute('data-free-ship'), 10) || 0;
    var nt;

    function open() { drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; }
    function close() { drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; }

    function vtitle(it) {
      if (!it.variant_title || it.variant_title.indexOf('Default') !== -1) return '';
      return '<div class="cd-variant">' + it.variant_title + '</div>';
    }
    function render(cart) {
      var c = cart.item_count;
      countEls.forEach(function (e) { e.textContent = '(' + c + ')'; });
      var badge = document.getElementById('brasil-cart-count'); if (badge) badge.textContent = c;
      if (subEl) subEl.textContent = euro(cart.total_price);
      if (noteEl && document.activeElement !== noteEl) noteEl.value = cart.note || '';
      var shipBox = drawer.querySelector('.cd-ship');
      var taxNote = drawer.querySelector('.cd-taxnote');
      if (!cart.requires_shipping) {
        // Digital-only cart (e.g. ebook): no shipping bar, clear message
        if (shipBox) shipBox.style.display = 'none';
        if (taxNote) taxNote.textContent = 'Produit numérique : aucun frais de livraison, téléchargement immédiat après paiement.';
      } else {
        if (shipBox) shipBox.style.display = '';
        if (taxNote) taxNote.textContent = 'Taxes et livraison calculées au paiement.';
        if (freeShip && shipMsg && shipFill) {
          if (cart.total_price >= freeShip) { shipMsg.innerHTML = '🎉 Vous bénéficiez de la <strong>livraison offerte</strong> !'; shipFill.style.width = '100%'; }
          else { shipMsg.innerHTML = 'Plus que <strong>' + euro(freeShip - cart.total_price) + '</strong> pour la livraison offerte'; shipFill.style.width = Math.min(100, cart.total_price / freeShip * 100) + '%'; }
        }
      }
      if (!cart.items.length) { itemsEl.innerHTML = ''; if (emptyEl) emptyEl.style.display = 'block'; itemsEl.style.display = 'none'; return; }
      if (emptyEl) emptyEl.style.display = 'none'; itemsEl.style.display = 'block';
      itemsEl.innerHTML = cart.items.map(function (it) {
        var img = it.image || '';
        if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=160';
        return '<div class="cd-item" data-key="' + it.key + '">' +
          '<a href="' + it.url + '" class="cd-thumb">' + (img ? '<img src="' + img + '" alt="" width="64" height="72">' : '') + '</a>' +
          '<div class="cd-info"><a href="' + it.url + '" class="cd-name">' + it.product_title + '</a>' + vtitle(it) +
          '<div class="cd-qty"><button type="button" data-cd-dec aria-label="Moins">&minus;</button><span>' + it.quantity + '</span><button type="button" data-cd-inc aria-label="Plus">+</button></div></div>' +
          '<div class="cd-right"><span class="cd-price">' + euro(it.final_line_price) + '</span><button type="button" class="cd-remove" data-cd-remove>Retirer</button></div>' +
          '</div>';
      }).join('');
    }
    function refresh() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(render); }
    function change(key, qty) {
      return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) }).then(function (r) { return r.json(); }).then(render);
    }

    // Open on cart icon click
    document.querySelectorAll('.cart-wrap').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); open(); refresh(); });
    });
    // Close
    drawer.querySelectorAll('[data-cd-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('open')) close(); });
    // Qty + remove (delegated)
    itemsEl.addEventListener('click', function (e) {
      var row = e.target.closest('.cd-item'); if (!row) return;
      var key = row.getAttribute('data-key');
      var qty = parseInt(row.querySelector('.cd-qty span').textContent, 10) || 1;
      if (e.target.closest('[data-cd-inc]')) change(key, qty + 1);
      else if (e.target.closest('[data-cd-dec]')) change(key, Math.max(0, qty - 1));
      else if (e.target.closest('[data-cd-remove]')) change(key, 0);
    });
    // Note
    if (noteEl) noteEl.addEventListener('input', function () {
      clearTimeout(nt);
      nt = setTimeout(function () { fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: noteEl.value }) }); }, 500);
    });

    // Expose a global opener so other scripts (e.g. bundle) can open the drawer
    window.BrasilOpenCart = function () { refresh().then(open).catch(open); };

    // Intercept add-to-cart submits site-wide (capture phase, before Dawn) → AJAX add + open
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;
      e.preventDefault(); e.stopPropagation();
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.classList.add('loading'); btn.setAttribute('disabled', 'disabled'); }
      var fd = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) { return r.json(); })
        .then(function () { return refresh(); })
        .then(function () { open(); })
        .catch(function () { form.submit(); })
        .then(function () { if (btn) { btn.classList.remove('loading'); btn.removeAttribute('disabled'); } });
    }, true);

    refresh();
  }

  /* ── Mobile accordions (footer columns, SEO columns) ── */
  function initMobileAccordion() {
    var mq = window.matchMedia('(max-width:749px)');
    [].slice.call(document.querySelectorAll('.brasil [data-macc]')).forEach(function (acc) {
      if (acc.__macc) return; acc.__macc = true;
      var head = acc.querySelector('[data-macc-head]') || acc.firstElementChild;
      if (!head) return;
      var body = document.createElement('div'); body.className = 'macc-body';
      var sib = head.nextElementSibling;
      while (sib) { var next = sib.nextElementSibling; body.appendChild(sib); sib = next; }
      acc.appendChild(body);
      head.classList.add('macc-head');
      head.addEventListener('click', function () { if (mq.matches) acc.classList.toggle('open'); });
    });
  }

  /* ── Slideshow (mobile-friendly image slider) ── */
  function initSlideshow() {
    [].slice.call(document.querySelectorAll('.brasil [data-slideshow]')).forEach(function (sl) {
      if (sl.__ss) return; sl.__ss = true;
      var track = sl.querySelector('.ss-track');
      var slides = [].slice.call(sl.querySelectorAll('.ss-slide'));
      var dotsWrap = sl.querySelector('.ss-dots');
      if (!track || slides.length < 2) return;
      var i = 0, timer, delay = parseInt(sl.getAttribute('data-interval'), 10) || 5000;
      var dots = slides.map(function (s, idx) {
        var d = document.createElement('button'); d.className = 'ss-dot'; d.setAttribute('aria-label', 'Slide ' + (idx + 1));
        d.addEventListener('click', function () { go(idx); reset(); });
        if (dotsWrap) dotsWrap.appendChild(d); return d;
      });
      function go(n) { i = (n + slides.length) % slides.length; track.style.transform = 'translateX(-' + (i * 100) + '%)'; dots.forEach(function (d, k) { d.classList.toggle('active', k === i); }); }
      function next() { go(i + 1); }
      function reset() { clearInterval(timer); timer = setInterval(next, delay); }
      var pa = sl.querySelector('.ss-prev'), na = sl.querySelector('.ss-next');
      if (pa) pa.addEventListener('click', function () { go(i - 1); reset(); });
      if (na) na.addEventListener('click', function () { go(i + 1); reset(); });
      go(0); reset();
      sl.addEventListener('mouseenter', function () { clearInterval(timer); });
      sl.addEventListener('mouseleave', reset);
    });
  }

  /* ── Welcome popup (once per N days) ── */
  function initPopup() {
    var pop = document.getElementById('BrasilPopup');
    if (!pop) return;
    var KEY = 'brasil_popup_seen';
    var days = parseInt(pop.getAttribute('data-days'), 10);
    var delay = parseInt(pop.getAttribute('data-delay'), 10) || 0;
    var design = document.documentElement.classList.contains('shopify-design-mode');
    function seen() {
      if (design || days === 0) return false;
      try { var t = parseInt(localStorage.getItem(KEY), 10); return t && (Date.now() - t) < days * 86400000; } catch (e) { return false; }
    }
    function open() { pop.classList.add('open'); pop.setAttribute('aria-hidden', 'false'); }
    function close() { pop.classList.remove('open'); pop.setAttribute('aria-hidden', 'true'); try { localStorage.setItem(KEY, Date.now()); } catch (e) {} }
    pop.querySelectorAll('[data-bpop-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && pop.classList.contains('open')) close(); });
    // If the form posted successfully, show immediately (Shopify reloads the page)
    if (pop.querySelector('.bpop-success')) { open(); return; }
    if (seen()) return;
    setTimeout(open, delay);
  }

  /* ── Chatbot (FAQ) + back-to-top ── */
  function initChat() {
    var chat = document.getElementById('BrasilChat');
    if (chat) {
      var panel = chat.querySelector('.bchat-panel');
      chat.querySelectorAll('[data-bchat-toggle]').forEach(function (b) {
        b.addEventListener('click', function () {
          var open = chat.classList.toggle('open');
          if (panel) panel.setAttribute('aria-hidden', open ? 'false' : 'true');
        });
      });
      chat.querySelectorAll('[data-bchat-q]').forEach(function (q) {
        q.addEventListener('click', function () {
          var faq = q.closest('.bchat-faq');
          var wasOpen = faq.classList.contains('open');
          chat.querySelectorAll('.bchat-faq.open').forEach(function (f) { f.classList.remove('open'); });
          if (!wasOpen) faq.classList.add('open');
        });
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') chat.classList.remove('open'); });
    }
    var top = document.querySelector('[data-bttop]');
    if (top) {
      top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
      var onScroll = function () { top.classList.toggle('show', window.pageYOffset > 500); };
      window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    }
  }

  /* ── Defer product-card hover images until first hover (perf) ── */
  function initHoverImages() {
    document.addEventListener('pointerover', function (e) {
      var card = e.target.closest && e.target.closest('.pc');
      if (!card) return;
      var h = card.querySelector('.pc-img-hover[data-bg]');
      if (h) { h.style.backgroundImage = "url('" + h.getAttribute('data-bg') + "')"; h.removeAttribute('data-bg'); }
    }, { passive: true });
  }

  function revealAll() {
    document.querySelectorAll('.brasil [data-reveal]').forEach(function (e) { e.classList.add('is-in'); });
  }

  /* ── Header is non-sticky (normal flow) so it never overlaps page content.
     Sticky was removed: the fixed wrapper + measured spacer offset was
     unreliable (spacer measured 0 → every page's top hid behind the header). ── */
  function initStickyHeader() {
    /* Clean up any leftover fixed positioning / spacer from a previous load. */
    var nav = document.querySelector('.navbar');
    if (!nav) return;
    var header = nav.closest('.shopify-section') || nav.parentElement;
    if (header && header.style.position === 'fixed') {
      header.style.position = '';
      header.style.top = '';
      header.style.left = '';
      header.style.right = '';
      header.style.zIndex = '';
    }
    var spacer = document.querySelector('.brasil-header-spacer');
    if (spacer && spacer.parentNode) spacer.parentNode.removeChild(spacer);
  }
  function init() {
    try { initReveal(); } catch (e) { revealAll(); }
    try { initStickyHeader(); } catch (e) {}
    try { initWishlist(); } catch (e) {}
    try { initSearch(); } catch (e) {}
    try { initCart(); } catch (e) {}
    try { initMobileAccordion(); } catch (e) {}
    try { initSlideshow(); } catch (e) {}
    try { initPopup(); } catch (e) {}
    try { initChat(); } catch (e) {}
    try { initHoverImages(); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
